import { domAnimation, LazyMotion, m } from 'framer-motion'

import { Dispatch, FC, ReactNode, SetStateAction, useEffect, useRef, useState } from 'react'

//interface
interface ICollapseProps {
  open: boolean
  children: ReactNode
  className?: string
  changeScrollPosition?: (value: number) => void
  setIsMoreText?: Dispatch<SetStateAction<boolean>>
  defaultHeight?: number
}

//components
const CollapseComponent: FC<Readonly<ICollapseProps>> = ({
  open,
  children,
  className,
  changeScrollPosition,
  setIsMoreText,
  defaultHeight,
}) => {
  const [isOpened, setIsOpened] = useState(open)
  const collapseRef = useRef<HTMLDivElement>(null)
  const [scrollPosition, setScrollPosition] = useState(0)

  const height = defaultHeight ?? 248

  useEffect(() => {
    const el = collapseRef?.current
    const handleScroll = () => {
      setScrollPosition(el?.scrollTop || 0)
      changeScrollPosition?.(el?.scrollTop || 0)
    }
    el?.addEventListener('scroll', handleScroll)
    return () => {
      el?.removeEventListener('scroll', handleScroll)
    }
  }, [changeScrollPosition])

  useEffect(() => {
    if (setIsMoreText)
      setIsMoreText(
        Number(collapseRef?.current?.scrollHeight) > Number(collapseRef?.current?.clientHeight),
      )
  }, [setIsMoreText])

  //return
  return (
    <LazyMotion features={domAnimation} strict>
      <m.div
        initial='collapsed'
        ref={collapseRef}
        animate={open ? 'open' : 'collapsed'}
        onAnimationComplete={(res) => {
          setIsOpened(res === 'open')
        }}
        onAnimationStart={() => {
          setIsOpened(false)
        }}
        variants={{
          open: {
            width: '100%',
            height: 'auto',
          },
          collapsed: {
            width: '100%',
            height: setIsMoreText ? height : 0,
            overflow: 'hidden',
          },
        }}
        className={className}
        data-is-opened={isOpened || undefined}
        data-is-scrolled={!!scrollPosition || undefined}
      >
        {children}
      </m.div>
    </LazyMotion>
  )
}

export default CollapseComponent
